import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { TrendingUp, Users, Target, DollarSign } from 'lucide-react';
const stats = [{
  value: 320,
  suffix: '%',
  label: 'Leads generados',
  icon: Users,
  prefix: '+'
}, {
  value: 4.7,
  suffix: 'X',
  label: 'ROAS promedio',
  icon: TrendingUp,
  prefix: '',
  decimals: 1
}, {
  value: 38,
  suffix: '%',
  label: 'Costo por adquisición',
  icon: Target,
  prefix: '-'
}, {
  value: 210,
  suffix: '%',
  label: 'Conversión comercial',
  icon: DollarSign,
  prefix: '+'
}];
function Counter({
  value,
  decimals = 0
}: {
  value: number;
  decimals?: number;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  useEffect(() => {
    if (isInView) {
      let start = 0;
      const end = value;
      const duration = 2000;
      const incrementTime = 20;
      const steps = duration / incrementTime;
      const increment = end / steps;
      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          clearInterval(timer);
          setCount(end);
        } else {
          setCount(start);
        }
      }, incrementTime);
      return () => clearInterval(timer);
    }
  }, [isInView, value]);
  return <span ref={ref} data-id="element-201">{count.toFixed(decimals)}</span>;
}
export function Results() {
  return <section id="resultados" className="py-24 bg-brand-cyan relative overflow-hidden" data-id="element-202">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-white/10 rounded-full blur-[80px] -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-203" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-black/5 rounded-full blur-[80px] translate-y-1/2 -translate-x-1/3 pointer-events-none" data-id="element-204" />

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-205">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-206">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold mb-4 text-brand-black" data-id="element-207">
            Resultados que generan crecimiento.
          </motion.h2>
          <p className="text-lg text-brand-black/80 font-medium" data-id="element-208">
            Nuestros sistemas están diseñados para impactar directamente en el
            retorno de inversión.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-209">
          {stats.map((stat, index) => {
          const Icon = stat.icon;
          return <motion.div key={stat.label} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 border border-white/20 text-center group hover:bg-white hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-id="element-210">
                <div className="w-12 h-12 mx-auto rounded-full bg-brand-cyan/10 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:bg-brand-cyan/20 transition-all duration-300" data-id="element-211">
                  <Icon size={24} className="text-brand-cyan" data-id="element-212" />
                </div>
                <div className="text-4xl font-bold text-brand-black mb-2 font-montserrat" data-id="element-213">
                  {stat.prefix}
                  <Counter value={stat.value} decimals={stat.decimals} data-id="element-214" />
                  {stat.suffix}
                </div>
                <div className="text-sm font-bold text-slate-600 uppercase tracking-wide" data-id="element-215">
                  {stat.label}
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}